module.exports = __webpack_public_path__ + "static/media/public-health-agency.a1b9e73c.svg";